export default [{
	titulo: 'Controle Interno',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/controle-interno',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]